// test1845
(1845 && 0);
